import React from "react";

export default function Button({
  children,
  variant = "primary",
  onClick,
  className = "",
  ariaLabel,
}) {
  const cls = `btn ${
    variant === "primary"
      ? "primary"
      : variant === "secondary"
      ? "secondary"
      : ""
  } ${className}`;
  return (
    <button onClick={onClick} className={cls} aria-label={ariaLabel}>
      {children}
    </button>
  );
}
